export enum ErrorType {
  VALUTAKURS_INTERNAL_ERROR = 'VALUTAKURS_INTERNAL_ERROR',
  VALUTAKURS_VALUTAKURS_ERROR = 'VALUTAKURS_VALUTAKURS_ERROR',
  INTERNAL_SERVER_ERROR = 'Internal Server Error'
}
